import { Reveal } from "./Reveal";
import { TRUSTED_BY, TRUST_STATS } from "../lib/data";

export const TrustedBy = () => (
  <section data-testid="trusted-by" className="relative border-y border-[#D4AF37]/15 bg-[#080808]">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-12 md:py-16">
      <Reveal>
        <p className="text-center text-[11px] uppercase tracking-[0.3em] text-white/40 mb-8">Trusted Across Premium Events</p>
      </Reveal>
      <Reveal delay={0.08}>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 md:gap-x-12">
          {TRUSTED_BY.map((item, i) => (
            <span
              key={i}
              data-testid={`trusted-item-${i}`}
              className="font-display uppercase tracking-[0.12em] text-white/55 text-sm md:text-base"
            >
              {item}
            </span>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 border-t border-white/10 pt-10">
          {TRUST_STATS.map((s, i) => (
            <div key={i} data-testid={`trust-stat-${i}`} className="text-center">
              <div className="font-display font-black text-[#D4AF37] text-2xl md:text-4xl leading-none">{s.value}</div>
              <div className="mt-3 text-[10px] md:text-[11px] uppercase tracking-[0.16em] text-white/50 leading-relaxed">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
